import { Input, Spinner } from '@platform/components';

type NameCustomProjectContentProps = {
  name: string;
  setName: (name: string) => void;
  isSaving: boolean;
};

export const NameCustomProjectContent = (props: NameCustomProjectContentProps) => {
  const { name, setName, isSaving } = { ...props };

  return (
    <div className='flex flex-col gap-4 items-center mt-8 md:w-[500px]'>
      {isSaving ?
        <Spinner />
      : <>
          <div className='text-center text-xl'>
            What should we call this project? You can choose any name that you think describes the
            work you'll be doing.
          </div>
          <div className='mt-4'>
            <Input
              maxLength={120}
              customWidth={'md:w-[500px]'}
              type='inline'
              placeholder="For example, 'Grant proposal creation'"
              onChange={(e) => {
                setName(e.target.value);
              }}
              value={name}
              validate={(value: string) => {
                if (!value?.length) {
                  return 'Enter a project name to continue';
                }
              }}
              required
            />
          </div>
        </>
      }
    </div>
  );
};
